import { Box, Button, Chip, Paper, Stack, Typography } from "@mui/material";
import { DataGrid, getGridStringOperators, GridToolbar } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { useEffect, useState, useCallback, useContext } from "react";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import NodataImg from "../../assets/images/noData.png";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { useNavigate } from "react-router-dom";
import { quizListApi } from "../../store/quizzes/quizList";
import DeleteQuiz from "./deleteQuiz";
import { resetQuiz } from "../../store/quizzes/quizDetail";
import BulkQuiz from "./BulkQuiz";
import { ThemeContext } from '../../context/ThemeContext';
import CustomGridToolbar from "../../components/CustomGridToolbar";
import apiRoutes from "../../store/apiConfigs";
import BackdropUI from "../../ui/Backdrop";
import PublishUnpublishModule from "../../components/PublishUnpublishModule";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import DataGridComponent from "../../components/DataGridComponent";
import PermissionGate from "../../components/PermissionGate";

export default function ManageQuiz() {
  const quizList = useSelector((state) => state?.quizList);
  const { result, order_category, loading, total } = quizList;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDownload, setIsDownload] = useState(false)
  const [selectedRow, setSelectedRow] = useState([]);
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [bulkQuiz, setBulkQuiz] = useState(false);
  const { paginationModel, setPaginationModel } = useContext(ThemeContext)
  const [queryOptions, setQueryOptions] = useState({});
  const [publishModel, setPublishModel] = useState(false);

  const getQuizList = useCallback((queryOptions, paginationModel) => {
    const filterModel = queryOptions?.filterModel;
    const items = filterModel?.items;
    const firstItem = items && items.length > 0 ? items[0] : {};
    const quickFilterValues = filterModel?.quickFilterValues;

    const query = {
      page: paginationModel?.page + 1,
      page_size: paginationModel?.pageSize,
      field: firstItem.field || '',
      operator: firstItem.operator || (quickFilterValues && "contains") || '',
      value: firstItem.value || (quickFilterValues && quickFilterValues.toString().replaceAll(",", " ")) || ''
    };
    dispatch(quizListApi(query));
  }, [dispatch])


  const onFilterChange = useCallback((filterModel) => {
    setQueryOptions({ filterModel: { ...filterModel } });
  }, []);

  const columns = [
    {
      field: "id",
      headerName: "Quiz Id",
      filterable: false,
      sortable: false,
      width: 150,
    },
    {
      field: "title",
      headerName: "Title",
      filterable: true,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === 'equals' | operator.value === 'contains',
      ),
      sortable: false,
      width: 350,
    },

    {
      field: "duration",
      headerName: "Duration",
      filterable: false,
      sortable: false,
      width: 100,
    },
    {
      field: "banner",
      headerName: "Quiz Image",
      filterable: false,
      sortable: false,
      width: 250,
      renderCell: (params) => (
        <Box sx={{ py: 1 }}><img width={200} height={100} src={params.row.banner} alt='banner image' /></Box>)
    },
    {
      headerName: "Action",
      filterable: false,
      sortable: false,
      width: 200,
      disableExport: true,
      renderCell: (row) => (
        <>
          {
            <>
              <PermissionGate module="quizzes" action="update">
                <Button color="success" label="Available" variant="outlined"
                  onClick={() => navigate(`/edit-quiz/${row.id}`)}
                >
                  Edit
                </Button>
              </PermissionGate>
              <PermissionGate module="quizzes" action="delete">
                <Button
                  color="success"
                  label="Available"
                  variant="outlined"
                  style={{ marginLeft: "5px" }}
                  onClick={() => {
                    setNotSelectedProductModel(true)
                    setDeleteId(row.id)
                  }}
                >
                  Delete
                </Button>
              </PermissionGate>
            </>
          }
        </>
      ),
    },
    {
      field: "publish",
      headerName: "Publish Quiz",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="quizzes" action={row.row.published ? "unpublish" : "publish"}>
            <Button
              color="info"
              onClick={() => {
                setPublishModel(true)
                setDeleteId(row.id)
                setSelectedRow(row.row)
              }}
              endIcon={<ArrowRightAltIcon />}>
              {row.row.published ? "Unpublish" : "Publish"}
            </Button>
          </PermissionGate>
        </>
      ),
    },
  ];

  const addToCartHandler = async () => {

    navigate("/add-quiz");

  };

  useEffect(() => {
    getQuizList(queryOptions, paginationModel)
    dispatch(resetQuiz())
  }, [dispatch, queryOptions, paginationModel, getQuizList]);

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>


        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Quizzes List</Typography>
        </Stack>
        <Stack sx={{ my: 2 }} justifyContent="space-between" direction="row">
          <Stack direction="row" spacing={1}>

            <PermissionGate module="quizzes" action="create">
              <Button
                onClick={addToCartHandler}
                variant="contained"
              >
                Create New Quiz
              </Button>
            </PermissionGate>
            <PermissionGate module="quizzes" action="upload">
              <Button
                onClick={() => setBulkQuiz(true)}
                variant="contained"
              >
                Add Bulk Quizzes
              </Button>
            </PermissionGate>
          </Stack>
        </Stack>

        <Paper elevation={0}>
          <DataGridComponent
            loading={loading}
            rowCount={total}
            pageSize={paginationModel?.pageSize}
            onPageSizeChange={(newPageSize) => {
              setPaginationModel({
                ...paginationModel,
                pageSize: newPageSize,
              })
            }}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            sx={{
                    height: 500 
                }}
            getRowId={(row) => row.id}
            rows={result}
            columns={columns}
            onFilterModelChange={onFilterChange}
            slots={{
              noRowsOverlay: () => (
                <Box className="noData">
                  <img src={NodataImg} alt="no data found" />
                </Box>
              ),
              toolbar: (props) =>
                (CustomGridToolbar({ ...props, moduleType: "quizManagement", queryOptions: queryOptions, paginationModel: paginationModel, isDownload: isDownload, setIsDownload: setIsDownload, permissionModule: "quizzes", apiUrl: apiRoutes.quizList })),
            }}
            slotProps={{
loadingOverlay: {
      variant: 'linear-progress',
      noRowsVariant: 'linear-progress',
    },
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Paper>
      </Body>

      <DeleteQuiz
        open={notSelectedProductModel}
        setOpen={setNotSelectedProductModel}
        id={deleteId}
      />
      <BulkQuiz
        open={bulkQuiz}
        setOpen={setBulkQuiz}

      />
      <PublishUnpublishModule
        open={publishModel}
        setOpen={setPublishModel}
        selectedRow={selectedRow}
        queryOptions={queryOptions}
        paginationModel={paginationModel}
        moduleType={"quiz"}
        moduleList={getQuizList}
      />
      <BackdropUI open={isDownload} />
    </>
  );
}
